import { render, staticRenderFns } from "./trait_summary.vue?vue&type=template&id=0804b6f0&scoped=true&"
import script from "./trait_summary.vue?vue&type=script&lang=js&"
export * from "./trait_summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804b6f0",
  null
  
)

export default component.exports